import { Pipe, PipeTransform } from '@angular/core';
import { RoadOccupationFormValue } from '../forms/road-occupation.form';

@Pipe({
  name: 'occupationLabel',
  standalone: true
})
export class OccupationLabelPipe implements PipeTransform {

  public transform(value: RoadOccupationFormValue, index: number): string {
    switch (true) {
      case !!value?.purpose: {
        return `${index + 1}. ${value?.purpose}`;
      }
      case !!value?.surfaceViolation: {
        return `${index + 1}. ${value?.surfaceViolation}`;
      }
      case !!value?.deviceType: {
        return `${index + 1}. ${value?.deviceType}`;
      }
      default: {
        return `Zajęcie ${index + 1}.`;
      }
    }
  }

}
